import { Component, OnInit } from '@angular/core';
import { camps } from '../../../../models/models.generated';


@Component({
    templateUrl: './coupon-generate.modal.component.html',
    styleUrls: ['./coupon-generate.modal.component.scss'],
    standalone: false
})
export class CouponGenerateModalComponent implements OnInit {

    close: Function;

    value: camps.CouponInfo;

    constructor() { }

    ngOnInit() {

    }

    onClosed(item : camps.CouponInfo){
        this.value = item;
        this.close();
    }



}
